import { APIClient } from "./apiCore";
import axios from "axios";

const api = new APIClient();

const getPresignedUrl = () => {
  return api.get('/api/plan/upload-url');
};

const uploadFile = (url: string, file: File) => {
  return api.update(url, file);
};

const processPlan = () => {
    return api.create('/lambda/process-file');
}

const deletePlan = () => {
  return api.create('/api/plan/delete')
}

const applyMasking = (processedText: string, detectedPII: Array<[string, string]>, version: string = "unknown") => {
    return api.create('/api/plan/apply-masking', { processedText, detectedPII, version });
}

export {
    getPresignedUrl,
    processPlan,
    uploadFile,
    applyMasking,
    deletePlan
};
